import { z } from 'zod';
import { TimestampSchema } from './common';

/**
 * Only *custom* rooms/categories are persisted (PRD §8.6–8.7). The defaults
 * are app-level i18n enum keys (see enums.ts), so they stay translated across
 * he/en/ru/fr and are never stored. A custom entry holds the user's typed
 * string verbatim (single language, as entered).
 */
export const CustomRoomSchema = z.object({
  id: z.string().min(1),
  name: z.string().trim().min(1).max(60),
  sortOrder: z.number().int().optional(),
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type CustomRoom = z.infer<typeof CustomRoomSchema>;

export const CustomCategorySchema = z.object({
  id: z.string().min(1),
  name: z.string().trim().min(1).max(60),
  sortOrder: z.number().int().optional(),
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type CustomCategory = z.infer<typeof CustomCategorySchema>;
